var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#EDF8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.773 39.818c0-2.232 1.87-4.044 4.173-4.044h48.107c2.305 0 4.172 1.812 4.172 4.044v48.365c0 2.232-1.867 4.043-4.172 4.043H39.946c-2.304 0-4.173-1.81-4.173-4.043V39.817z",
    fill: "#91A9B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.93 83.016V57.602h-8.448v25.414h8.448zm-4.223-28.884c2.945 0 4.779-1.951 4.779-4.39-.055-2.495-1.834-4.392-4.723-4.392-2.891 0-4.78 1.897-4.78 4.392 0 2.439 1.834 4.39 4.669 4.39h.055zm8.898 28.884h8.447v-14.19c0-.76.055-1.52.278-2.062.61-1.518 2-3.09 4.334-3.09 3.056 0 4.28 2.33 4.28 5.748v13.594h8.446V68.444c0-7.806-4.167-11.438-9.724-11.438-4.557 0-6.558 2.547-7.67 4.281h.056v-3.684h-8.447c.11 2.384 0 25.414 0 25.414z",
    fill: "#EDF8FA"
  })));
};
export default SvgLinkedin;